var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.documents),function(document,index){return _c('div',{staticClass:"file_box",on:{"click":function($event){$event.preventDefault();return _vm.onClickPreviewFile({index})}}},[_c('a',{staticClass:"file",attrs:{"href":"#"}},[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(document.fileName))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }